import { useEffect } from "react";
import "./styles/bookingtoast.css";

const BookingToast = ({ toast, onDismiss }) => {
	useEffect(() => {
		if (!toast) return;
		const timer = setTimeout(onDismiss, 6000);
		return () => clearTimeout(timer);
	}, [toast, onDismiss]);

	if (!toast) return null;

	return (
		<div className="bt-toast" role="alert">
			<div className="bt-toast-icon">{toast.kind === "purchase" ? "🛍️" : "📅"}</div>
			<div className="bt-toast-body">
				<p className="bt-toast-title">{toast.title}</p>
				<p className="bt-toast-msg">{toast.body}</p>
			</div>
			<button className="bt-toast-close" onClick={onDismiss} aria-label="Dismiss">
				×
			</button>
		</div>
	);
};

export default BookingToast;